/**
 * @author mschuetz / http://mschuetz.at
 *
 *
 */

import * as THREE from '../../libs/three.js/build/three.module.js';
import { KeyCodes } from '../KeyCodes.js';
import { Utils } from '../utils.js';
import { EventDispatcher } from '../EventDispatcher.js';
import JSON5 from '../../libs/json5-2.1.3/json5.mjs';

export class InputHandler extends EventDispatcher {
  constructor(viewer) {
    super();

    this.viewer = viewer;
    this.renderer = viewer.renderer;
    this.domElement = this.renderer.domElement;
    this.enabled = true;

    this.scene = null;
    this.interactiveScenes = [];
    this.interactiveObjects = new Set();
    this.inputListeners = [];
    this.blacklist = new Set();

    this.drag = null;
    this.mouse = new THREE.Vector2(0, 0);

    this.selection = [];

    this.hoveredElements = [];
    this.pressedKeys = {};

    this.wheelDelta = 0;

    this.speed = 1;

    this.logMessages = false;

    this.lastObject = null;

    this.isCameraToggled = false;

    // Measure mode flag - when true, navigation drag/drop events are not dispatched to controllers
    this.measureModeEnabled = false;

    // Touch gesture tracking
    this.activeTouches = new Map(); // Map<touchId, {startTime, startPos, currentPos}>
    this.lastTapTime = 0;
    this.lastTapPosition = null;
    this.doubleTapTimeout = 300; // ms
    this.longPressTimeout = 500; // ms
    this.longPressTimers = new Map(); // Map<touchId, timer>

    // Middle mouse button double click tracking. The browser only fires `dblclick`
    // for the primary button, so this gesture is detected from the raw mousedowns.
    this.lastMiddleDown = null; // {time, x, y}
    this.middleDoubleClickTimeout = 300; // ms
    this.middleDoubleClickDistance = 5; // px

    //this._dataStringArray = [];
    // if (sessionStorage.getItem('dataStringArray')) {
    //   this._dataStringArray = JSON5.parse(
    //     sessionStorage.getItem('dataStringArray')
    //   );
    // }

    // this.currentStorageIndex =
    //   sessionStorage.getItem('currentStorageIndex') !== null
    //     ? Number(sessionStorage.getItem('currentStorageIndex'))
    //     : 0;
    // if (sessionStorage.getItem('loadIndexes')) {
    //   this._loadIndexes = new Map(
    //     JSON5.parse(sessionStorage.getItem('loadIndexes'))
    //   );
    // } else {
    //   this._loadIndexes = new Map();
    // }

    if (this.domElement.tabIndex === -1) {
      this.domElement.tabIndex = 2222;
    }

    // document.addEventListener('keydown', function (event) {
    //   if (event.ctrlKey && event.key === 'x') {
    //     const storedJsonString = localStorage.getItem('localSavedProject');
    //     const storedJsonData = JSON5.parse(storedJsonString);
    //     Potree.loadProject(viewer, storedJsonData);
    //     viewer.postMessage('Project loaded from local storage.', {
    //       duration: 1500,
    //     });
    //     event.preventDefault();
    //   }
    // });

    // document.addEventListener('keydown', function (event) {
    //   if (event.ctrlKey && event.key === 's') {
    //     const time = new Date().toISOString();
    //     let data = Potree.saveProject(viewer);
    //     let dataString = JSON5.stringify(data, null, '\t');
    //     localStorage.setItem('localSavedProject', dataString);
    //     localStorage.setItem('localSavedProjectTime', time);
    //     viewer.postMessage('Project saved in local storage.', {
    //       duration: 1500,
    //     });
    //     event.preventDefault();
    //   }
    // });

    // document.addEventListener('keydown', function (event) {
    //   if (event.key === 'Delete') {
    //     if (confirm('Delete data from local storage?')) {
    //       localStorage.clear();
    //       sessionStorage.clear();
    //     }
    //     event.preventDefault();
    //   }
    // });
    //CTRL+Z
    // document.addEventListener('keydown', function (event) {
    //   if (event.ctrlKey && event.key === 'z') {
    //     viewer.inputHandler.currentStorageIndex -= 1;
    //     if (viewer.inputHandler.currentStorageIndex < 0) {
    //       viewer.inputHandler.currentStorageIndex += 1;
    //       return;
    //     }

    //     if (
    //       viewer.inputHandler.loadIndexes.has(
    //         viewer.inputHandler.currentStorageIndex
    //       ) &&
    //       viewer.inputHandler.currentStorageIndex > 0
    //     ) {
    //       if (
    //         viewer.inputHandler.loadIndexes.get(
    //           viewer.inputHandler.currentStorageIndex
    //         ) === 'load'
    //       ) {
    //         sessionStorage.setItem('isLoad', true);
    //         const url = window.location.href;
    //         //window.location.href = url;
    //       }
    //     }

    //     const storedJsonString =
    //       viewer.inputHandler.dataStringArray[
    //         viewer.inputHandler.currentStorageIndex
    //       ];
    //     while (viewer.scene.orientedImages.length > 0) {
    //       viewer.scene.removeOrientedImages(viewer.scene.orientedImages[0]);
    //     }
    //     while (viewer.scene.images360.length > 0) {
    //       viewer.scene.remove360Images(viewer.scene.images360[0]);
    //     }
    //     while (viewer.scene.geopackages.length > 0) {
    //       viewer.scene.removeGeopackage(viewer.scene.geopackages[0]);
    //     }
    //     while (viewer.scene.cameraAnimations.length > 0) {
    //       viewer.scene.removeCameraAnimation(viewer.scene.cameraAnimations[0]);
    //     }
    //     viewer.scene.removeAllMeasurements();
    //     viewer.scene.removeAllClipVolumes();

    //     let storedJsonData = JSON5.parse(storedJsonString);
    //     Object.defineProperty(storedJsonData, 'undo', { value: true });
    //     Potree.loadProject(viewer, storedJsonData);
    //     viewer.postMessage('Undo', {
    //       duration: 1500,
    //     });
    //     event.preventDefault();
    //   }
    // });

    // document.addEventListener('keydown', function (event) {
    //   if (event.ctrlKey && event.key === 'y') {
    //     viewer.inputHandler.currentStorageIndex += 1;
    //     if (
    //       viewer.inputHandler.currentStorageIndex >=
    //       viewer.inputHandler._dataStringArray.length
    //     ) {
    //       viewer.inputHandler.currentStorageIndex -= 1;
    //       return;
    //     }
    //     const storedJsonString =
    //       viewer.inputHandler._dataStringArray[
    //       viewer.inputHandler.currentStorageIndex
    //       ];

    //     while (viewer.scene.orientedImages.length > 0) {
    //       viewer.scene.removeOrientedImages(viewer.scene.orientedImages[0]);
    //     }
    //     while (viewer.scene.images360.length > 0) {
    //       viewer.scene.remove360Images(viewer.scene.images360[0]);
    //     }
    //     while (viewer.scene.geopackages.length > 0) {
    //       viewer.scene.removeGeopackage(viewer.scene.geopackages[0]);
    //     }
    //     while (viewer.scene.cameraAnimations.length > 0) {
    //       viewer.scene.removeCameraAnimation(viewer.scene.cameraAnimations[0]);
    //     }
    //     viewer.scene.removeAllMeasurements();
    //     viewer.scene.removeAllClipVolumes();

    //     let storedJsonData = JSON5.parse(storedJsonString);
    //     Object.defineProperty(storedJsonData, 'undo', { value: true });
    //     Potree.loadProject(viewer, storedJsonData);
    //     viewer.postMessage('Redo', {
    //       duration: 1500,
    //     });
    //     event.preventDefault();
    //   }
    // });

    // let saveOnTimer = () => {
    //   const time = new Date().toISOString();
    //   let data = Potree.saveProject(viewer);
    //   let dataString = JSON5.stringify(data, null, '\t');
    //   localStorage.setItem('localTimerSavedProject', dataString);
    //   localStorage.setItem('localTimerSavedProjectTime', time);
    //   this.viewer.postMessage('Project saved in local storage.', {
    //     duration: 1500,
    //   });
    // };

    // let saveOnAction = () => {
    //   if (this.currentStorageIndex !== this._dataStringArray.length) {
    //     this._dataStringArray = this._dataStringArray.slice(
    //       0,
    //       this.currentStorageIndex
    //     );
    //     for (let [key] of this._loadIndexes.entries()) {
    //       if (key > this.currentStorageIndex) {
    //         this._loadIndexes.delete(key);
    //       }
    //     }
    //   }

    //   let data = Potree.saveProject(this.viewer);
    //   let dataString = JSON5.stringify(data, null, '\t');
    //   if (
    //     dataString !== this._dataStringArray[this._dataStringArray.length - 1]
    //   ) {
    //     this._dataStringArray.push(dataString);
    //   }

    //   sessionStorage.setItem(
    //     'dataStringArray',
    //     JSON5.stringify(this._dataStringArray)
    //   );
    //   sessionStorage.setItem('currentStorageIndex', this.currentStorageIndex);
    //   sessionStorage.setItem(
    //     'loadIndexes',
    //     JSON5.stringify(Array.from(this._loadIndexes.entries()))
    //   );
    // };

    //const saveInterval = setInterval(saveOnTimer, 600000);

    this.domElement.addEventListener(
      'contextmenu',
      (event) => {
        event.preventDefault();
      },
      false
    );
    this.domElement.addEventListener(
      'click',
      this.onMouseClick.bind(this),
      false
    );
    this.domElement.addEventListener(
      'mousedown',
      this.onMouseDown.bind(this),
      false
    );
    this.domElement.addEventListener(
      'mouseup',
      this.onMouseUp.bind(this),
      false
    );
    this.domElement.addEventListener(
      'mousemove',
      this.onMouseMove.bind(this),
      false
    );
    this.domElement.addEventListener(
      'mousewheel',
      this.onMouseWheel.bind(this),
      false
    );
    this.domElement.addEventListener(
      'DOMMouseScroll',
      this.onMouseWheel.bind(this),
      false
    ); // Firefox
    this.domElement.addEventListener('dblclick', this.onDoubleClick.bind(this));
    this.domElement.addEventListener('keydown', this.onKeyDown.bind(this));
    this.domElement.addEventListener('keyup', this.onKeyUp.bind(this));
    this.domElement.addEventListener(
      'touchstart',
      this.onTouchStart.bind(this)
    );
    this.domElement.addEventListener('touchend', this.onTouchEnd.bind(this));
    this.domElement.addEventListener('touchmove', this.onTouchMove.bind(this));

    // Prevent long-press context menu and browser zoom gestures on iOS Chrome/Safari
    // pan-x pan-y allows panning but disables browser's pinch-zoom
    // Our JavaScript handles pinch gestures for camera controls
    this.domElement.style.touchAction = 'pan-x pan-y';

    //this.addEventListener('save_action', saveOnAction);
  }

  addInputListener(listener) {
    this.inputListeners.push(listener);
  }

  removeInputListener(listener) {
    this.inputListeners = this.inputListeners.filter((e) => e !== listener);
  }

  getSortedListeners() {
    return this.inputListeners.sort((a, b) => {
      let ia = a.importance !== undefined ? a.importance : 0;
      let ib = b.importance !== undefined ? b.importance : 0;

      return ib - ia;
    });
  }

  onTouchStart(e) {
    e.preventDefault();
    
    // Additional prevention for iOS context menu that may fire after long press
    // Add a temporary contextmenu listener that will fire if iOS tries to show menu
    const preventContextMenu = (evt) => {
      evt.preventDefault();
      evt.stopPropagation();
      evt.stopImmediatePropagation();
    };
    
    // Add temporary listener that removes itself after touchend
    const removeContextPrevention = () => {
      this.domElement.removeEventListener('contextmenu', preventContextMenu, true);
      document.removeEventListener('touchend', removeContextPrevention, true);
    };
    
    this.domElement.addEventListener('contextmenu', preventContextMenu, true);
    document.addEventListener('touchend', removeContextPrevention, { once: true, capture: true });

    let now = Date.now();
    let rect = this.domElement.getBoundingClientRect();

    // Track all touches
    for (let touch of e.changedTouches) {
      let x = touch.pageX - rect.left;
      let y = touch.pageY - rect.top;
      let pos = new THREE.Vector2(x, y);

      this.activeTouches.set(touch.identifier, {
        startTime: now,
        startPos: pos.clone(),
        currentPos: pos.clone(),
        hasMoved: false
      });

      // Set up long press timer
      let timer = setTimeout(() => {
        if (this.activeTouches.has(touch.identifier)) {
          let touchData = this.activeTouches.get(touch.identifier);
          touchData.isLongPress = true;
          
          // For single touch, trigger middle mouse button behavior
          if (e.touches.length === 1) {
            this.emulateMouseEvent('mousedown', touch, THREE.MOUSE.MIDDLE, x, y);
          }
        }
      }, this.longPressTimeout);
      
      this.longPressTimers.set(touch.identifier, timer);
    }

    if (e.touches.length === 1) {
      let x = e.touches[0].pageX - rect.left;
      let y = e.touches[0].pageY - rect.top;
      this.mouse.set(x, y);

      // Check for double tap (disabled in measure mode)
      if (!this.measureModeEnabled && this.lastTapTime > 0 && (now - this.lastTapTime) < this.doubleTapTimeout) {
        let dist = this.lastTapPosition ? this.lastTapPosition.distanceTo(new THREE.Vector2(x, y)) : Infinity;
        if (dist < 50) { // 50px threshold for double tap
          // Emulate double click
          this.emulateDoubleClick(x, y);
          this.lastTapTime = 0;
          this.lastTapPosition = null;
          return;
        }
      }

      // Emulate mousedown
      this.emulateMouseEvent('mousedown', e.touches[0], THREE.MOUSE.LEFT, x, y);

      // Only start a new drag if there isn't one already (tools like AnnotationTool may have started one)
      if (!this.drag) {
        this.startDragging(null);
      } else {
        // Update drag start/end position for existing drag
        this.drag.start = this.mouse.clone();
        this.drag.end = this.mouse.clone();
        this.drag.lastDrag = new THREE.Vector2(0, 0);
      }
    }

    for (let inputListener of this.getSortedListeners()) {
      inputListener.dispatchEvent({
        type: e.type,
        touches: e.touches,
        changedTouches: e.changedTouches,
      });
    }
  }

  onTouchEnd(e) {
    e.preventDefault();

    let now = Date.now();
    let rect = this.domElement.getBoundingClientRect();

    // Process ended touches
    for (let touch of e.changedTouches) {
      let touchData = this.activeTouches.get(touch.identifier);
      
      // Clear long press timer
      if (this.longPressTimers.has(touch.identifier)) {
        clearTimeout(this.longPressTimers.get(touch.identifier));
        this.longPressTimers.delete(touch.identifier);
      }

      if (touchData) {
        let x = touch.pageX - rect.left;
        let y = touch.pageY - rect.top;
        let moved = touchData.hasMoved;
        let isLongPress = touchData.isLongPress || false;
        let timeHeld = now - touchData.startTime;

        this.activeTouches.delete(touch.identifier);

        // Single touch handling - only process if this was the last touch
        if (this.activeTouches.size === 0 && e.touches.length === 0) {
          if (isLongPress) {
            // Long press - emulate middle mouse button
            this.emulateMouseEvent('mouseup', touch, THREE.MOUSE.MIDDLE, x, y);
          } else if (!moved && timeHeld < this.longPressTimeout) {
            // Tap - check for potential double tap
            let button = THREE.MOUSE.LEFT;
            
            // If this was a long press during insertion (detected by context), use RIGHT
            // This will be handled by tools that need it
            this.emulateMouseEvent('mouseup', touch, button, x, y);
            
            // Store for potential double tap
            this.lastTapTime = now;
            this.lastTapPosition = new THREE.Vector2(x, y);
          } else {
            // Drag ended
            this.emulateMouseEvent('mouseup', touch, THREE.MOUSE.LEFT, x, y);
          }
        }
      }
    }

    // Note: drop events are dispatched by onMouseUp which is called via emulateMouseEvent
    // We don't dispatch them again here to avoid double dispatch
    this.drag = null;

    // Don't dispatch touch events to navigation controllers in measure mode
    if (!this.measureModeEnabled) {
      for (let inputListener of this.getSortedListeners()) {
        inputListener.dispatchEvent({
          type: e.type,
          touches: e.touches,
          changedTouches: e.changedTouches,
        });
      }
    }
  }

  onTouchMove(e) {
    e.preventDefault();

    let rect = this.domElement.getBoundingClientRect();

    // Update touch positions and detect movement
    for (let touch of e.touches) {
      let touchData = this.activeTouches.get(touch.identifier);
      if (touchData) {
        let x = touch.pageX - rect.left;
        let y = touch.pageY - rect.top;
        let newPos = new THREE.Vector2(x, y);
        
        // Detect if touch has moved significantly (more than 5px)
        if (!touchData.hasMoved && touchData.startPos.distanceTo(newPos) > 5) {
          touchData.hasMoved = true;
          // Cancel long press timer if moved
          if (this.longPressTimers.has(touch.identifier)) {
            clearTimeout(this.longPressTimers.get(touch.identifier));
            this.longPressTimers.delete(touch.identifier);
          }
        }
        
        touchData.currentPos = newPos;
      }
    }

    if (e.touches.length === 1) {
      let touchData = this.activeTouches.get(e.touches[0].identifier);
      if (touchData) {
        let x = touchData.currentPos.x;
        let y = touchData.currentPos.y;
        this.mouse.set(x, y);

        // Emulate mousemove
        this.emulateMouseEvent('mousemove', e.touches[0], THREE.MOUSE.LEFT, x, y);

        if (this.drag) {
          this.drag.mouse = 1;

          this.drag.lastDrag.x = x - this.drag.end.x;
          this.drag.lastDrag.y = y - this.drag.end.y;

          this.drag.end.set(x, y);

          // Dispatch drag to the dragged object (important for tools like AnnotationTool)
          if (this.drag.object) {
            this.drag.object.dispatchEvent({
              type: 'drag',
              drag: this.drag,
              viewer: this.viewer,
            });
          } else {
            // Don't dispatch drag events to navigation controllers in measure mode
            if (!this.measureModeEnabled) {
              for (let inputListener of this.getSortedListeners()) {
                inputListener.dispatchEvent({
                  type: 'drag',
                  drag: this.drag,
                  viewer: this.viewer,
                });
              }
            }
          }
        }
      }
    }

    // Pass touch events to listeners (for multi-touch gestures like pinch/pan)
    // Don't dispatch to navigation controllers in measure mode
    if (!this.measureModeEnabled) {
      for (let inputListener of this.getSortedListeners()) {
        inputListener.dispatchEvent({
          type: e.type,
          touches: e.touches,
          changedTouches: e.changedTouches,
        });
      }
    }

    // DEBUG CODE
    // let debugTouches = [...e.touches, {
    //	pageX: this.domElement.clientWidth / 2,
    //	pageY: this.domElement.clientHeight / 2}];
    // for(let inputListener of this.getSortedListeners()){
    //	inputListener.dispatchEvent({
    //		type: e.type,
    //		touches: debugTouches,
    //		changedTouches: e.changedTouches
    //	});
    // }
  }

  onKeyDown(e) {
    // DELETE
    if (e.keyCode === KeyCodes.DELETE && this.selection.length > 0) {
      this.dispatchEvent({
        type: 'delete',
        selection: this.selection,
      });

      this.deselectAll();
    }

    this.dispatchEvent({
      type: 'keydown',
      keyCode: e.keyCode,
      event: e,
    });

    // for(let l of this.getSortedListeners()){
    //	l.dispatchEvent({
    //		type: "keydown",
    //		keyCode: e.keyCode,
    //		event: e
    //	});
    // }

    this.pressedKeys[e.keyCode] = true;

    // e.preventDefault();
  }

  onKeyUp(e) {
    if (e.key === 'Escape') {
      this.drag = null;
      this.deselectAll();
    }

    delete this.pressedKeys[e.keyCode];

    e.preventDefault();
  }

  onDoubleClick(e) {
    // Block double click for navigation in measure mode
    if (this.measureModeEnabled) {
      e.preventDefault();
      return;
    }

    // Block double click while inside a focused panorama to prevent
    // the camera from flying out of the sphere.
    const anyFocused = this.viewer.scene.images360.some(
      inst => inst.focusedImage !== null
    );
    if (anyFocused) {
      e.preventDefault();
      return;
    }

    let consumed = false;
    for (let hovered of this.hoveredElements) {
      if (hovered._listeners && hovered._listeners['dblclick']) {
        hovered.object.dispatchEvent({
          type: 'dblclick',
          mouse: this.mouse,
          object: hovered.object,
        });
        consumed = true;
        break;
      }
    }

    if (!consumed) {
      for (let inputListener of this.getSortedListeners()) {
        inputListener.dispatchEvent({
          type: 'dblclick',
          mouse: this.mouse,
          object: null,
        });
      }
    }

    e.preventDefault();
  }

  onMouseClick(e) {
    e.preventDefault();
  }

  isMiddleDoubleClick (e) {
		const previous = this.lastMiddleDown;
		const current = { time: performance.now(), x: e.clientX, y: e.clientY };
		this.lastMiddleDown = current;

		if (previous === null) {
			return false;
		}

		const inTime = current.time - previous.time <= this.middleDoubleClickTimeout;
		const inPlace =
			Math.abs(current.x - previous.x) <= this.middleDoubleClickDistance &&
			Math.abs(current.y - previous.y) <= this.middleDoubleClickDistance;

		if (inTime && inPlace) {
			// Don't let a third click chain into another double click.
			this.lastMiddleDown = null;
			return true;
		}

		return false;
	}

	onMiddleDoubleClick () {
		// Fit to screen is a camera move, so it is subject to the same restrictions as
		// the primary button double click: not while measuring, not inside a panorama.
		if (this.measureModeEnabled) {
			return;
		}

		const anyFocused = this.viewer.scene.images360.some(
			inst => inst.focusedImage !== null
		);
		if (anyFocused) {
			return;
		}

		this.viewer.fitToScreen();
	}

	onMouseDown (e) {
		e.preventDefault();

		if (e.button === THREE.MOUSE.MIDDLE && this.isMiddleDoubleClick(e)) {
			this.onMiddleDoubleClick();
		}

		let consumed = false;
		let consume = () => { return consumed = true; };
		if (this.hoveredElements.length === 0) {
			// Don't dispatch mousedown to navigation controllers in measure mode
			if (!this.measureModeEnabled) {
				for (let inputListener of this.getSortedListeners()) {
					inputListener.dispatchEvent({
						type: 'mousedown',
						viewer: this.viewer,
						mouse: this.mouse
					});
				}
			}
		}else{
			for(let hovered of this.hoveredElements){
				let object = hovered.object;
				object.dispatchEvent({
					type: 'mousedown',
					viewer: this.viewer,
					consume: consume
				});

				if(consumed){
					break;
				}
			}
		}

		if (!this.drag) {
			let target = this.hoveredElements
				.find(el => (
					el.object._listeners &&
					el.object._listeners['drag'] &&
					el.object._listeners['drag'].length > 0));

			if (target) {
				this.startDragging(target.object, {location: target.point});
			} else {
				// Only start dragging for navigation if not in measure mode
				if (!this.measureModeEnabled) {
					this.startDragging(null);
				}
			}
		}

		if (this.scene && !this.measureModeEnabled) {
			this.viewStart = this.scene.view.clone();
		}
	}

  get dataStringArray() {
    return this._dataStringArray;
  }

  set dataStringArray(dataStringArray) {
    this._dataStringArray = dataStringArray;
  }

  get storageIndex() {
    return this.currentStorageIndex;
  }

  set storageIndex(storageIndex) {
    this.currentStorageIndex = storageIndex;
  }

  get loadIndexes() {
    return this._loadIndexes;
  }

  set loadIndexes(loadIndexes) {
    this._loadIndexes = loadIndexes;
  }

  onMouseUp (e) {
		e.preventDefault();

		let noMovement = this.getNormalizedDrag().length() === 0;

		
		let consumed = false;
		let consume = () => { return consumed = true; };
		if (this.hoveredElements.length === 0) {
			// Don't dispatch mouseup to navigation controllers in measure mode
			if (!this.measureModeEnabled) {
				for (let inputListener of this.getSortedListeners()) {
					inputListener.dispatchEvent({
						type: 'mouseup',
						viewer: this.viewer,
						mouse: this.mouse,
						consume: consume
					});

					if(consumed){
						break;
					}
				}
			}
		}else{
			let hovered = this.hoveredElements
				.map(e => e.object)
				.find(e => (e._listeners && e._listeners['mouseup']));
			if(hovered){
				hovered.dispatchEvent({
					type: 'mouseup',
					viewer: this.viewer,
					consume: consume,
					button: e.button
				});
			}
		}

		if (this.drag) {
			if (this.drag.object) {
				this.drag.object.dispatchEvent({
					type: 'drop',
					drag: this.drag,
					viewer: this.viewer

				});
			} else {
				// Don't dispatch drop to navigation controllers in measure mode
				if (!this.measureModeEnabled) {
					for (let inputListener of this.getSortedListeners()) {
						inputListener.dispatchEvent({
							type: 'drop',
							drag: this.drag,
							viewer: this.viewer
						});
					}
				}
			}

			// check for a click
			let clicked = this.hoveredElements.map(h => h.object).find(v => v === this.drag.object) !== undefined;
if(clicked){
				this.drag.object.dispatchEvent({
					type: 'click',
					viewer: this.viewer,
					consume: consume,
				});
			}

			this.drag = null;
		}

		if(!consumed){
			if (e.button === THREE.MOUSE.LEFT) {
				if (noMovement) {
					let selectable = this.hoveredElements
						.find(el => el.object._listeners && el.object._listeners['select']);

					if (selectable) {
						selectable = selectable.object;

						if (this.isSelected(selectable)) {
							this.selection
								.filter(e => e !== selectable)
								.forEach(e => this.toggleSelection(e));
						} else {
							this.deselectAll();
							this.toggleSelection(selectable);
						}
					} else {
						this.deselectAll();
					}
				}
			} else if ((e.button === THREE.MOUSE.RIGHT) && noMovement) {
				this.deselectAll();
			}
		}
	}

  onMouseMove(e) {
    e.preventDefault();

    let rect = this.domElement.getBoundingClientRect();
    let x = e.clientX - rect.left;
    let y = e.clientY - rect.top;
    this.mouse.set(x, y);

    let hoveredElements = this.getHoveredElements();
    if (hoveredElements.length > 0) {
      let names = hoveredElements.map((h) => h.object.name).join(', ');
    }

    if (this.drag) {
      this.drag.mouse = e.buttons;

      this.drag.lastDrag.x = x - this.drag.end.x;
      this.drag.lastDrag.y = y - this.drag.end.y;

      this.drag.end.set(x, y);

      if (this.drag.object) {
        this.drag.object.dispatchEvent({
          type: 'drag',
          drag: this.drag,
          viewer: this.viewer,
        });
      } else {

        // Don't dispatch drag to navigation controllers in measure mode
        if (!this.measureModeEnabled) {
          let dragConsumed = false;
          for (let inputListener of this.getSortedListeners()) {
            inputListener.dispatchEvent({
              type: 'drag',
              drag: this.drag,
              viewer: this.viewer,
              consume: () => {
                dragConsumed = true;
              },
            });

            if (dragConsumed) {
              break;
            }
          }
        }
      }
    } else {
      let curr = hoveredElements.map((a) => a.object).find((a) => true);
      let prev = this.hoveredElements.map((a) => a.object).find((a) => true);

      if (curr !== prev) {
        if (curr) {
          curr.dispatchEvent({
            type: 'mouseover',
            object: curr,
          });
        }
        if (prev) {
          prev.dispatchEvent({
            type: 'mouseleave',
            object: prev,
          });
        }
      }

      if (hoveredElements.length > 0) {
        let object = hoveredElements
          .map((e) => e.object)
          .find((e) => e._listeners && e._listeners['mousemove']);

        if (object) {
          object.dispatchEvent({
            type: 'mousemove',
            object: object,
          });
        }
      }
    }

    // for (let inputListener of this.getSortedListeners()) {
    // 	inputListener.dispatchEvent({
    // 		type: 'mousemove',
    // 		object: null
    // 	});
    // }

    this.hoveredElements = hoveredElements;
  }

  onMouseWheel(e) {
    if (!this.enabled) return;

    e.preventDefault();

    let delta = 0;
    if (e.wheelDelta !== undefined) {
      // WebKit / Opera / Explorer 9
      delta = e.wheelDelta;
    } else if (e.detail !== undefined) {
      // Firefox
      delta = -e.detail;
    }

    let ndelta = Math.sign(delta);

    // this.wheelDelta += Math.sign(delta);

    if (this.hoveredElement) {
      this.hoveredElement.object.dispatchEvent({
        type: 'mousewheel',
        delta: ndelta,
        object: this.hoveredElement.object,
      });
    } else {
      for (let inputListener of this.getSortedListeners()) {
        inputListener.dispatchEvent({
          type: 'mousewheel',
          delta: ndelta,
          object: null,
        });
      }
    }
  }

  startDragging(object, args = null) {
    this.drag = {
      start: this.mouse.clone(),
      end: this.mouse.clone(),
      lastDrag: new THREE.Vector2(0, 0),
      startView: this.scene.view.clone(),
      object: object,
    };

    if (args) {
      for (let key of Object.keys(args)) {
        this.drag[key] = args[key];
      }
    }
  }

  getMousePointCloudIntersection(mouse) {
    return Utils.getMousePointCloudIntersection(
      this.mouse,
      this.scene.getActiveCamera(),
      this.viewer,
      this.scene.pointclouds
    );
  }

  toggleSelection(object) {
    let oldSelection = this.selection;

    let index = this.selection.indexOf(object);

    if (index === -1) {
      this.selection.push(object);
      object.dispatchEvent({
        type: 'select',
      });
    } else {
      this.selection.splice(index, 1);
      object.dispatchEvent({
        type: 'deselect',
      });
    }

    this.dispatchEvent({
      type: 'selection_changed',
      oldSelection: oldSelection,
      selection: this.selection,
    });
  }

  deselect(object) {
    let oldSelection = this.selection;

    let index = this.selection.indexOf(object);

    if (index >= 0) {
      this.selection.splice(index, 1);
      object.dispatchEvent({
        type: 'deselect',
      });

      this.dispatchEvent({
        type: 'selection_changed',
        oldSelection: oldSelection,
        selection: this.selection,
      });
    }
  }

  deselectAll() {
    for (let object of this.selection) {
      object.dispatchEvent({
        type: 'deselect',
      });
    }

    let oldSelection = this.selection;

    if (this.selection.length > 0) {
      this.selection = [];
      this.dispatchEvent({
        type: 'selection_changed',
        oldSelection: oldSelection,
        selection: this.selection,
      });
    }
  }

  isSelected(object) {
    let index = this.selection.indexOf(object);

    return index !== -1;
  }

  registerInteractiveObject(object) {
    this.interactiveObjects.add(object);
  }

  removeInteractiveObject(object) {
    this.interactiveObjects.delete(object);
  }

  registerInteractiveScene(scene) {
    let index = this.interactiveScenes.indexOf(scene);
    if (index === -1) {
      this.interactiveScenes.push(scene);
    }
  }

  unregisterInteractiveScene(scene) {
    let index = this.interactiveScenes.indexOf(scene);
    if (index > -1) {
      this.interactiveScenes.splice(index, 1);
    }
  }

  getHoveredElement() {
    let hoveredElements = this.getHoveredElements();
    if (hoveredElements.length > 0) {
      return hoveredElements[0];
    } else {
      return null;
    }
  }

  getHoveredElements() {
    let scenes = this.interactiveScenes.concat(this.scene.scene);

    let interactableListeners = [
      'mouseup',
      'mousemove',
      'mouseover',
      'mouseleave',
      'drag',
      'drop',
      'click',
      'select',
      'deselect',
    ];
    let interactables = [];
    for (let scene of scenes) {
      scene.traverseVisible((node) => {
        if (node._listeners && node.visible && !this.blacklist.has(node)) {
          let hasInteractableListener =
            interactableListeners.filter((e) => {
              return node._listeners[e] !== undefined;
            }).length > 0;

          if (hasInteractableListener) {
            interactables.push(node);
          }
        }
      });
    }

    let camera = this.scene.getActiveCamera();
    let ray = Utils.mouseToRay(
      this.mouse,
      camera,
      this.domElement.clientWidth,
      this.domElement.clientHeight
    );

    let raycaster = new THREE.Raycaster();
    raycaster.ray.set(ray.origin, ray.direction);
    raycaster.params.Line.threshold = 0.2;

    let intersections = raycaster.intersectObjects(
      interactables.filter((o) => o.visible),
      false
    );

    return intersections;
  }

  setScene(scene) {
    this.deselectAll();

    this.scene = scene;
  }

  update(delta) { }

  getNormalizedDrag() {
    if (!this.drag) {
      return new THREE.Vector2(0, 0);
    }

    let diff = new THREE.Vector2().subVectors(this.drag.end, this.drag.start);

    diff.x = diff.x / this.domElement.clientWidth;
    diff.y = diff.y / this.domElement.clientHeight;

    return diff;
  }

  getNormalizedLastDrag() {
    if (!this.drag) {
      return new THREE.Vector2(0, 0);
    }

    let lastDrag = this.drag.lastDrag.clone();

    lastDrag.x = lastDrag.x / this.domElement.clientWidth;
    lastDrag.y = lastDrag.y / this.domElement.clientHeight;

    return lastDrag;
  }

  /**
   * Calculate distance between two touches for pinch gesture
   */
  getTouchDistance(touch1, touch2) {
    let rect = this.domElement.getBoundingClientRect();
    let x1 = touch1.pageX - rect.left;
    let y1 = touch1.pageY - rect.top;
    let x2 = touch2.pageX - rect.left;
    let y2 = touch2.pageY - rect.top;
    return Math.sqrt((x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1));
  }

  /**
   * Calculate center point between two touches for pan gesture
   */
  getTouchCenter(touch1, touch2) {
    let rect = this.domElement.getBoundingClientRect();
    let x1 = touch1.pageX - rect.left;
    let y1 = touch1.pageY - rect.top;
    let x2 = touch2.pageX - rect.left;
    let y2 = touch2.pageY - rect.top;
    return new THREE.Vector2((x1 + x2) / 2, (y1 + y2) / 2);
  }

  /**
   * Emulate mouse event from touch event
   */
  emulateMouseEvent(type, touch, button, x, y) {
    let rect = this.domElement.getBoundingClientRect();
    let clientX = touch.pageX || x + rect.left;
    let clientY = touch.pageY || y + rect.top;
    
    // Create a real DOM MouseEvent that will propagate to all listeners
    let event = new MouseEvent(type, {
      bubbles: true,
      cancelable: true,
      view: window,
      button: button || THREE.MOUSE.LEFT,
      buttons: button === THREE.MOUSE.LEFT ? 1 : button === THREE.MOUSE.RIGHT ? 2 : button === THREE.MOUSE.MIDDLE ? 4 : 0,
      clientX: clientX,
      clientY: clientY,
      screenX: touch.screenX || clientX,
      screenY: touch.screenY || clientY,
      relatedTarget: null
    });
    
    // Add custom properties that Potree expects
    event.mouse = this.mouse.clone();
    event.drag = this.drag;
    event.viewer = this.viewer;
    
    // Dispatch to DOM element first (for tools that listen directly)
    this.domElement.dispatchEvent(event);
    
    // Also call internal handlers to maintain existing behavior
    if (type === 'mousedown') {
      this.onMouseDown(event);
    } else if (type === 'mouseup') {
      this.onMouseUp(event);
    } else if (type === 'mousemove') {
      this.onMouseMove(event);
    }
  }

  /**
   * Emulate double click from double tap
   */
  emulateDoubleClick(x, y) {
    // Block double tap in measure mode
    if (this.measureModeEnabled) {
      return;
    }
    
    this.mouse.set(x, y);
    
    // Create a synthetic double click event
    let event = new MouseEvent('dblclick', {
      bubbles: true,
      cancelable: true,
      view: window,
      button: 0,
      buttons: 0,
      clientX: x,
      clientY: y
    });
    
    event.mouse = this.mouse.clone();
    this.onDoubleClick(event);
  }
}
